<template>
  <FormCompleteProfile v-if="profileCompletionPending" />
  <template v-else>
    <LazyFormSignup
      v-if="authenticationProvider === 'email' && authenticationType === 'Signup'"
      :owner-signup="authenticationIntent === 'ListingIntent'"
    />

    <LazyFormLogin v-else-if="authenticationProvider === 'email' && authenticationType === 'Login'" />

    <template v-else>
      <FormAuthProviders
        :auth-type="authenticationType"
        :intent="authenticationIntent"
        :redirect-path="redirectPath"
        class="mt-4"
        @show-login-form="updateEmailForm('Login')"
        @show-signup-form="updateEmailForm('Signup')"
      />

      <p class="text-sm text-center">
        <template v-if="isSignupVisible">
          {{ t('auth.signup.haveAnAccount') }}
          <a
            :href="localePath('index-signin')"
           
            class="link"
            @click.prevent="toggleAuthForm"
          >{{ t('auth.login.cta') }}</a>
        </template>
        <template v-else>
          {{ t('auth.login.noAccount') }}
          <a
            :href="localePath('index-signup')"
            class="link"
            @click.prevent="toggleAuthForm"
          >{{ t('auth.signup.cta') }}</a>
        </template>
      </p>
    </template>

    <I18nT
      v-if="isSignupVisible"
      keypath="auth.signup.terms.text"
      tag="p"
      class="mt-6 text-center text-text-muted text-xs"
    >
      <NuxtLink
        target="_blank"
        :to="localePath('terms-service')"
        class="link-muted"
      >{{ t('auth.signup.terms.yearsOld') }}</NuxtLink>

      <NuxtLink
        target="_blank"
        :to="localePath('terms-service')"
        class="link-muted"
      >
        {{ t('auth.signup.terms.termsOfService') }}
      </NuxtLink>

      <NuxtLink
        target="_blank"
        :to="localePath('privacy-policy')"
        class="link-muted"
      >
        {{ t('auth.signup.terms.privacyPolicy') }}
      </NuxtLink>
    </I18nT>
  </template>
</template>

<script setup lang="ts">
import type { AUTHENTICATION_TYPE } from '~/constants/authentication'

defineProps<{
  redirectPath?: string
}>()

const emit = defineEmits<{
  'toggle-auth-form': []
}>()

const { t } = useI18n()

const localePath = useLocalePath()
const profileCompletionPending = useProfileCompletionPending()

const { authenticationType, authenticationProvider } = useAuthentication()

function updateEmailForm(value: AUTHENTICATION_TYPE) {
  authenticationType.value = value
  authenticationProvider.value = 'email'
}

const { authenticationIntent, isSignupVisible } = useSignup()

function toggleAuthForm() {
  emit('toggle-auth-form')
}
</script>

<i18n src="~~/i18n/locales/common/auth/signup.json" lang="json" />

<i18n src="~~/i18n/locales/common/auth/login.json" lang="json" />
